import { Backdrop as MuiBackdrop } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Backdrop = styled(MuiBackdrop)(() => ({
  backgroundColor: 'rgba(0, 0, 0, 0.25)',
  zIndex: -2,
}));
